import React from 'react';
import {Route, Switch} from "react-router-dom";
import '../../mobile.css';
import Footer from "../../../shared/MiniCenteredFooter";
import Header from "../../../shared/SiteHeader";
import MobileHome from "./Home";
import AboutUs from "../../../shared/AboutUs";
import VersusPage from "../../../shared/VersusPage";
import ResearchPage from "../../../shared/ResearchPage";
import tw from "twin.macro";

const Page = tw.div`min-h-screen w-full flex flex-col`;
const Container = tw.div`mr-2 ml-2 mt-20 flex-grow`;

function TeamApp(){
    return (
        <Switch>
            <Route exact path="/">
                <MobileHome />
            </Route>
            <Route path="/versus/:slug">
                <Page>
                    <Header />
                    <Container>
                        <VersusPage isMobile />
                    </Container>
                    <Footer />
                </Page>
            </Route>
            <Route path="/research">
                <Page>
                    <Header />
                    <Container>
                        <ResearchPage isMobile />
                    </Container>
                    <Footer />
                </Page>
            </Route>
            <Route path="/aboutus">
                <Page>
                    <Header />
                    <Container>
                        <AboutUs isMobile />
                    </Container>
                    <Footer />
                </Page>
            </Route>
        </Switch>
    );
}

export default TeamApp;